<template>
	<div id="floating-basket" @click="goToBasket">
	    <i class="fa fa-shopping-basket"></i>
        <span class="bottom-badge">{{ basketCount }}</span>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		computed: {
			...mapGetters({
				basketCount: 'Basket/getCount'
			})
		},

        methods: {
            goToBasket() {
                this.$router.push({ name: 'basket' });
            }
        }
	}
</script>

<style scoped>
    #floating-basket {
    	width: 50px;
    	right: 10px;
    	height: 50px;
    	bottom: 10px;
    	color: #ffffff;
    	position: fixed;
    	z-index: 9999999;
    	border-radius: 50%;
    	background: #00abc0;
    	border: 2px solid #00abc0;
    	padding: 15px 30px 20px 10px;	
		box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(244, 67, 54, 0.4);
    }

    .fa-shopping-basket {
    	font-size: 1.5em;
    }

    .bottom-badge {
    	top: 6px;
    	right: 20%;
    	padding: 2px 1px 0 2px;
    	color: #00abc0;
    	font-size: 0.8em;
    	background: white;
    	position: absolute;
    	border-radius: 50px;
    }
</style>


// WEBPACK FOOTER //
// FloatingBasket.vue?218ae342